export const Region_List = [
    {
        "label": "India",
        "value": 1,
        "stateID": 1
    },
    {
        "label": "Kuwait",
        "value": 2,
        "stateID": 2
    },
]